<template>
  <div class="home">
    <a-row class="home-head">
      <a-col :span="8">
        <p>内攻区</p>
      </a-col>
      <a-col :span="16">
        <p>
          集结区
          <router-link class="total-btn" to="/allteam">全部队员</router-link>
        </p>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="8">
        <div class="team-major">
          <ul v-if="TeamMemberListIsSide && TeamMemberListIsSide.length>0" class="yes-there">
            <li v-for="(item,index) in TeamMemberListIsSide" :key="index">
              <font>{{item.GroupName}}</font>
              {{item.Name}}
              <button @click="removeInner(item.SN)">移除</button>
            </li>
          </ul>

          <div v-else class="no-there">
            <img src="../assets/images/nav_icon_shutdown_nornal.png" alt />
            <p>
              暂无内攻人员
              <br />请在集结区设置
            </p>
          </div>
        </div>
      </a-col>
      <a-col :span="16">
        <div v-if="groups.length">
          <div class="allteam-top">
            <div>
              <img
                @click="activeHideAll"
                class="selected-img"
                id="selecte-all"
                src="../assets/images/selected-img.png"
              />
              <input type="checkbox" class="active-all" @click="activeAll" />
            </div>
            <ul class="team-top">
              <li
                @click="getGroup(index,group)"
                :class="{selected : groupIndex == index}"
                v-for="(group,index) in groups"
                :key="index"
              >{{group}}</li>
            </ul>
            <span @click="addInner">设为内攻</span>
          </div>
          <ul class="team-list" @touchstart="touchSatrt" @touchmove="touchMove" @touchend="touchEnd">
            <li v-for="(item,index) in TeamMemberListByGroup" :key="index">
              <img
                @click="activeHide"
                :index="item.SN"
                class="selected-img"
                id="selecte"
                src="../assets/images/selected-img.png"
              />
              <input
                class="check-box"
                :index="item.SN"
                :value="item.SN"
                v-model="checkedId"
                type="checkbox"
                @click="active"
              />
              <img src="../assets/images/icon_teammate.png" v-if="item.Name!='S'" class="user-head-img"/>
              <img src="../assets/images/icon_teammate_offline.png" v-else class="user-head-img"/>
              <span>{{item.Name}}</span>
              <span>{{item.NO}}</span>
              {{item.SN}}
            </li>
          </ul>
        </div>
        <div v-else class="no-there-aggr">
          <div class="no-there">
            <img src="../assets/images/team_img_info_none.png" alt />
            <p>暂无上线人员</p>
          </div>
        </div>
      </a-col>
      <div style="width:100%;height:100%;background:#576371;position: absolute; display:flex;" v-show="loadTeamImg">
        <img src="../assets/load-img.gif" style="width:10%;display: block; margin: auto;">
      </div>
    </a-row>

    <transition name="fade">
      <div class="team-box" v-show="teamBox">
        <h4>
          提示
          <!--<span @click="closeBox">×</span>-->
        </h4>
        <p>{{teamBoxContent}}</p>
        <div>
          <button @click="cancal">取消</button>
          <button @click="save">确定<strong id="save-load"></strong></button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import AllTeamService from "../api/AllTeamService";
export default {
  inject: ["reload"],
  data() {
    return {
      groupIndex: 0,
      groupName: "",
      innerTeams: [],
      teamList: [],
      groups: [],
      checkedId: [],
      teamBox: false,
      teamBoxContent: "",
      isThere: true,
      isThereAggr: true, 
      innerSN: "",
      contentHeight: "",
      teamListLen: 0,
      TeamMemberList: [],
      TeamMemberListIsSide: [], //内攻区队员
      TeamMemberListByGroup: [], //集结区根据组别选择的队员
      startX:0,
      startY:0,
      endX:0,
      endY:0,
      currentGroupIndex:0,
      loadTeamImg:true
    };
  },
  mounted() {
    this.contentHeight =
      document.body.offsetHeight -
      document.getElementsByClassName("home-head")[0].offsetHeight;
      document.getElementsByClassName("team-major")[0].style.minHeight =
      this.contentHeight + "px";

      document.getElementsByClassName('no-there-aggr')[0].style.height=this.contentHeight+'px'

    let that = this;
    document.body.onclick = function(e) {
      if (e.target.id == "mask") {
        that.delMask();
        that.teamBox = false;
      }
    };
  },
  created() {
    this.getTeamInfo()
    setInterval(()=>{
      //this.getTeamInfo('next')
    },10000)
  },
  computed: {
    /*TeamMemberList() {
	      return this.$store.state.TeamMemberList;
	    } */
  },
  watch: {
    /*TeamMemberList(to, from){ 
	  		//console.log(this.TeamMemberList)
	  		let data = this.TeamMemberList 
	      	let tempArr=[] 
	      	let dataArr=[]
	      	let innerFlag=0
	      	let aggreFlag=0 
	      	for (let i=0;i<data.length;i++) {
	      		if(data[i].IsInit && data[i].IsOnline){
	      			
	      		 
		      		
		      		if(data[i].IsInside==true){
		      			innerFlag++
		      		}else{
		      			aggreFlag++
		      		}
		      		
		      		if(tempArr.indexOf(data[i].GroupName) == '-1'){
		      			tempArr.push(data[i].GroupName)
		      			var tempObj={} 
		      			tempObj.data = [data[i]]  
		      			tempObj.GroupName = data[i].GroupName  
		      			dataArr.push(tempObj) 
		      			
		      		}else{
		      			let isInside = true
		      			let isInsideIndex=0
		      			for (let j=0;j<dataArr.length;j++) {
		      				if(dataArr[j].GroupName == data[i].GroupName){ 
		      					dataArr[j].data.push(data[i])
		      				}
		      			} 
		      		}     
		      		this.group = dataArr  
		      		this.teamList = dataArr[this.groupIndex] 
		      	}
	      	} 
	      	
	      	if(innerFlag==0){
	      		this.isThere=false
	      	}else{
	      		this.isThere=true
	      	} 
	      	if(aggreFlag==0){
	      		this.isThereAggr=false
	      		setTimeout(()=>{
	      			document.getElementsByClassName('no-there-aggr')[0].style.minHeight = this.contentHeight + 'px'
	      		},0)
	      		
	      	}else{
	      		this.isThereAggr=true
	      	} 
	  	},
	  	teamList(to, from){ 
	  		if(this.teamListLen !=0){
	  			if(this.teamListLen != this.teamList.data.length){
		  			//this.reload()
		  			if(this.teamListLen < this.teamList.data.length){ 
		  				document.getElementById('selecte-all').style.display='none'
		  			}else if(this.teamList.data.length == this.checkedId.length){
		  				document.getElementById('selecte-all').style.display='block'

		  				let checkLen = document.getElementsByClassName('check-box')

		  				for (var i = 0; i < checkLen.length; i++) {
		  					checkLen[i].click()
		  				}
		  			}
		  			console.log(this.teamListLen)
		  			console.log(this.teamList.data.length)
		  			console.log(this.checkedId.length)
		  		}
	  		} 
	  		this.teamListLen = this.teamList.data.length 
	  	}*/
  },
  methods: {
    touchSatrt(e){ 
      let touch=e.touches[0]  
      this.startX = touch.pageX           
      this.startY = touch.pageY 
    },
    touchMove(e){
      let touch = e.touches[0]             
      this.endX = this.startX - touch.pageX 
      this.endY = this.startY - touch.pageY    
    },
    touchEnd(){ 
      if(this.endX < -20 && this.endY < 30){
        if(this.currentGroupIndex>0){ 
          this.currentGroupIndex--
          this.getGroup(this.currentGroupIndex,this.groups[this.currentGroupIndex])
        } 
      }else if(this.endX > 20 && this.endY < 30){
        if(this.currentGroupIndex<this.groups.length-1){
          this.currentGroupIndex++ 
          this.getGroup(this.currentGroupIndex,this.groups[this.currentGroupIndex])
        } 
      }
    },
    getTeamInfo(f) { 
      AllTeamService.getTroopsTeamMemberStatus().then(
        res => {
          if (res.status == 200) {
            if (res.data.status == 1000) {
              this.TeamMemberList = res.data.data;
              this.loadTeamImg=false
              for (var i = 0; i < this.TeamMemberList.length; i++) {
                if (this.TeamMemberList[i].IsInside) {
                  //获取内攻区队员   
                  let f = false
                  for (var j = 0; j < this.TeamMemberListIsSide.length; j++) {
                    if(this.TeamMemberListIsSide[j].SN == this.TeamMemberList[i].SN){
                      f=true 
                    }
                  } 
                  if(f==false){
                    this.TeamMemberListIsSide.push(this.TeamMemberList[i])
                  }
                } else {
                  //获取组别
                  if (
                    this.groups.indexOf(this.TeamMemberList[i].GroupName) ==
                    "-1"
                  ) {
                    this.groups.push(this.TeamMemberList[i].GroupName);
                  }
                  //获取集结区队员
                  if(f != 'next'){
                    if (this.TeamMemberList[i].GroupName == this.groups[0]) { 
                      let f = false
                      for (var j = 0; j < this.TeamMemberListByGroup.length; j++) {
                        if(this.TeamMemberListByGroup[j].SN == this.TeamMemberList[i].SN){
                          f=true 
                        }
                      } 
                      if(f==false){
                        this.TeamMemberListByGroup.push(this.TeamMemberList[i])
                      } 
                    }
                  }
                  
                }
              }
            } else {
              this.$message.warning(res.data.msg);
            }
          } else {
            this.$message.warning(res.message);
          }
        },
        err => { 
          if (err && err.stack.indexOf('timeout') > -1) {
            this.$message.warning('连接超时,正在重新连接')
            this.getTeamInfo()
          }else{
            this.$message.warning(err.message)
          } 
        }
      );
    },
    cancal() {
      this.teamBox = false;
      this.delMask();
    },
    save(e) {
      document.getElementById("save-load").style.display = "inline-block"
      if (this.teamBoxContent == "是否将队员移出内攻区？") {
        //删除内政人员重新回到集结区
        AllTeamService.backToConcentrate({ SN: this.innerSN }).then(
          res => {
            if (res.status == 200) {
              if (res.data.status == 1000) {
                document.getElementById("save-load").style.display = "none"
                this.$message.success("操作成功");
                this.teamBox = false;
                this.delMask(); 
                this.reload() 
              } else {
                document.getElementById("save-load").style.display = "none"
                this.$message.warning(res.data.msg)
                this.teamBox = false;
                this.delMask();
              }
            } else {
              document.getElementById("save-load").style.display = "none"
              this.$message.warning(res.message)
              this.teamBox = false;
              this.delMask()
            }
          },
          err => {
            document.getElementById("save-load").style.display = "none"
            if (err && err.stack.indexOf('timeout') > -1) {
              this.$message.warning('连接超时,请重试') 
            }else{
              this.$message.warning(err.message)
            } 
            this.teamBox = false
            this.delMask();
          }
        );
      } else {
        //从集结区调人员回到内政区
        AllTeamService.backToInside({ SN: this.checkedId.join() }).then(
          res => {
            if (res.status == 200) {
              if (res.data.status == 1000) {
                document.getElementById("save-load").style.display = "none"
                this.$message.success("操作成功");
                this.teamBox = false;
                this.delMask()
                this.reload() 
              } else {
                document.getElementById("save-load").style.display = "none"
                this.$message.warning(res.data.msg)
                this.teamBox = false;
                this.delMask();
              }
            } else {
              document.getElementById("save-load").style.display = "none"
              this.$message.warning(res.message);
              this.teamBox = false;
              this.delMask();
            }
          },
          err => {
            document.getElementById("save-load").style.display = "none"
            if (err && err.stack.indexOf('timeout') > -1) {
              this.$message.warning('连接超时,请重试') 
            }else{
              this.$message.warning(err.message)
            } 
            this.teamBox = false;
            this.delMask();
          }
        );
      }
    },
    delMask() {
      var mask = document.getElementById("mask");
      mask.parentNode.removeChild(mask);
    },
    addMask() {
      var div = document.createElement("div");
      div.id = "mask";
      document.body.appendChild(div);
    },
    removeInner(sn) {
      this.innerSN = sn;
      this.teamBox = true;
      this.addMask();
      this.teamBoxContent = "是否将队员移出内攻区？";
    },
    addInner() {
      if (this.checkedId.length == 0) {
        this.$error({
          title: "提示",
          content: "请选择数据...",
          okText: "确定",
          centered: true
        });
      } else {
        this.teamBox = true;
        this.addMask();
        this.teamBoxContent = "是否将队员设置为内攻人员？";
      }
    },

    getGroup(index, item) {
      this.checkedId = [];
      document.getElementsByClassName(
        "active-all"
      )[0].previousElementSibling.style.display = "none";
      for (
        let i = 0;
        i < document.getElementsByClassName("check-box").length;
        i++
      ) {
        document.getElementsByClassName("check-box")[
          i
        ].previousElementSibling.style.display = "none";
        document.getElementsByClassName("check-box")[i].checked = false;
      }

      this.groupIndex = index;
      this.TeamMemberListByGroup = [];
      for (var i = 0; i < this.TeamMemberList.length; i++) {
        if (this.TeamMemberList[i].GroupName == item) { 
           
            this.TeamMemberListByGroup.push(this.TeamMemberList[i])
           
        }
      }

      document.getElementsByClassName("active-all")[0].checked = false;
      for (
        let i = 0;
        i < document.getElementsByClassName("check-box").length;
        i++
      ) {
        document.getElementsByClassName("check-box")[i].checked = false;
      }
    },
    active(e) {
      /*if(!e.target.checked){
	  			e.target.previousElementSibling.style.display='none'
	  			e.target.checked=false 
	  		}else{
	  			e.target.previousElementSibling.style.display='block'
	  			e.target.checked=true 
	  		}*/

      e.target.previousElementSibling.style.display = "block";
      e.target.checked = true;

      let li = document
        .getElementsByClassName("team-list")[0]
        .getElementsByTagName("li");
      let countNum = 0;
      for (var i = 0; i < li.length; i++) {
        if (li[i].getAttribute("style") == null) {
          countNum++;
        }
      }
      let checkEle = document.getElementsByClassName("check-box");
      let count = 0;
      for (var i = 0; i < countNum; i++) {
        if (checkEle[i].checked) {
          count++;
        }
      }
      if (count == countNum) {
        document.getElementById("selecte-all").style.display = "block";
      } else {
        document.getElementById("selecte-all").style.display = "none";
      }
    },
    activeHide(e) {
      document.getElementById("selecte-all").style.display = "none";
      document.getElementsByClassName("active-all")[0].checked = false;
      e.target.style.display = "none";
      for (var i = 0; i < this.checkedId.length; i++) {
        if (this.checkedId[i] == e.target.getAttribute("index")) {
          this.checkedId.splice(i, 1);
        }
      }
      e.target.nextElementSibling.checked = false;
    },
    activeAll(e) {
      let checkEle = document.getElementsByClassName("check-box");
      for (var i = 0; i < checkEle.length; i++) {
        checkEle[i].click();
        if (checkEle[i].checked == false) {
          checkEle[i].click();
        }
      }
    },
    activeHideAll(e) {
      e.target.style.display = "none";
      e.target.nextElementSibling.checked = false;
      for (
        var i = 0;
        i < document.getElementsByClassName("check-box").length;
        i++
      ) {
        document.getElementsByClassName("check-box")[
          i
        ].previousElementSibling.style.display = "none";
        document.getElementsByClassName("check-box")[i].checked = false;
      }
      this.checkedId = [];
    }
  }
};
</script>
<style lang="less" scoped>
.fade-enter-active {
  animation: bounce-in 0.4s;
}
.fade-leave-active {
  animation: bounce-in 0.4s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.2);
  }
  100% {
    transform: scale(1);
  }
}
.offLine {
  color: #3f4650 !important;
}
.team-box {
  position: fixed;
  width: 340px;
  height: 240px;
  left: 50%;
  top: 50%;
  margin: -170px 0 0 -120px;
  border-radius: 10px;
  background: #fff;
  z-index: 1;
  text-align: center;
  font-size: 18px;
  h4 {
    font-size: 20px;
    font-weight: 600;
    padding: 20px 0;
  }
  p {
    height: 42px;
  }
  button {
    cursor: pointer;
    background: #40dc23;
    line-height: 50px;
    text-align: center;
    color: #fff;
    border: 0;
    margin-top: 30px;
    border-radius: 5px;
    font-size: 20px;
    width: 120px;
  }
  button:first-child {
    background: #fff;
    border: 1px solid #40dc23;
    color: #40dc23;
    margin-right: 60px;
  }
  strong{
    display: none; 
    width: 22px;
    height: 22px;
    border: 3px solid #fff;
    border-right: 0;
    border-radius: 50%;
    margin-bottom: -3px;
    animation: myfirst 0.5s linear infinite;
  }
}
@keyframes myfirst {
  0% {
    transition: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.selected {
  border-bottom: 4px solid #2c9918;
  color: #2c9918 !important;
}
.total-btn {
  width: 100px;
  text-align: center;
  margin-top: 22px;
  margin-right: 17px;
  height: 30px;
  line-height: 30px;
  background: #40dc23;
  border-radius: 25px;
  font-size: 18px;
  color: #fff;
  float: right;
}
.team-major {
  display: table;
  width: 100%;
  border-right: 1px solid #14161a;
  li {
    border-top: 1px solid #575b64;
    padding: 0 26px;
    line-height: 60px;
    background: #2d313a;
    font-size: 20px;
    color: #fff;
    font {
      padding-right: 30px;
    }
    button {
      background: #5f666e;
      padding: 0px 10px;
      border: 0;
      border-radius: 15px;
      line-height: 23px;
      font-size: 14px;
      float: right;
      margin-top: 19px;
      cursor: pointer;
    }
  }
}
.no-there {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  p {
    margin-top: 30px;
    color: #fff;
    font-size: 18px;
  }
}
.no-there-aggr {
  display: table;
  width: 100%;
  height: 93.9vh;
  background: #dddce2;
  img {
    width: 120px;
  }
  p {
    color: #666;
  }
}
.allteam-top {
  div {
    float: left;
    width: 59px;
    input {
      margin: 18px 0 0 25px;
      width: 20px;
      height: 20px;
      border: 0;
    }
    input:before {
      content: "";
      display: block;
      width: 21px;
      height: 21px;
      background: #eee;
      border-radius: 4px;
      position: absolute;
      left: 24px;
      top: 17px;
    }
    .selected-img {
      display: none;
      width: 22px;
      position: absolute;
      left: 24px;
      top: 17px;
      z-index: 1;
    }
  }
  span {
    position: absolute;
    right: 15px;
    top: 20px;
    background: #40dc23;
    color: #fff;
    border-radius: 15px;
    padding: 3px 8px;
    cursor: pointer;
  }
}
.team-top {
  height: 61px;
  background: #2d313a;
  border-top: 1px solid #575b64;
  li {
    cursor: pointer;
    float: left;
    line-height: 56px;
    font-size: 20px;
    color: #fff;
    padding: 0 13px;
    /*margin:0 12px;*/
  }
}
.team-list {
  min-height: 86vh;
  li {
    position: relative;
    padding: 0 25px;
    line-height: 60px;
    border-bottom: 1px solid #575b64;
    font-size: 20px;
    color: #fff;
    input {
      width: 20px;
      height: 20px;
      border: 0;
    }
    input:before {
      content: "";
      display: block;
      width: 21px;
      height: 21px;
      background: #eee;
      border-radius: 4px;
      position: absolute;
      left: 24px;
      top: 17px;
    }
    .disable:before {
      background: #7f8b97;
    }
    span {
      display: inline-block;
      width: 130px;
    }
    img {
      width: 22px;
      margin: 0 15px 0 30px;
    }
    .selected-img {
      position: absolute;
      left: -6px;
      top: 17px;
      z-index: 1;
      display: none;
    }
  }
}
.yes-there {
  overflow: auto;
}
</style>

